import {RootState} from '@/store'
import {ActionTree} from 'vuex'
import {RequestPayload, ServiceApi} from '@payroll/optimus-common'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {LobbyDataState} from "@/store/modules/lobby/index";

export const actions: ActionTree<LobbyDataState, RootState> = {

    getBanners: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters['authorization/accessToken'])
            .setRequestName('getBanners')
            .setRequestBody(requestBody)
            .post(requestorCallback);
    },

    uploadBanner: ({commit, dispatch, state, rootGetters}: any, {formData, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters['authorization/accessToken'])
            .setFormData(formData)
            .setRequestName('uploadBanner')
            .post(requestorCallback);
    },

    deleteBanner: ({commit, dispatch, state, rootGetters}: any, {requestBody, pathVariable, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters['authorization/accessToken'])
            .setPathVariable(pathVariable)
            .setRequestName('deleteBanner')
            .post(requestorCallback);
    },

    getMngCompanyConfig: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters['authorization/accessToken'])
            .setRequestName('getMngCompanyConfig')
            .get(requestorCallback);
    },

    updateMngCompanyConfig: ({commit, dispatch, state, rootGetters}: any, {requestBody, pathVariable, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters['authorization/accessToken'])
            .setRequestBody(requestBody)
            .setPathVariable(pathVariable)
            .setRequestName('updateMngCompanyConfig')
            .post(requestorCallback);
    },

    uploadMngCompanyLogo: ({commit, dispatch, state, rootGetters}: any, {formData, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters['authorization/accessToken'])
            .setFormData(formData)
            .setRequestName('uploadMngCompanyLogo')
            .post(requestorCallback);
    },

    getLobbyData: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('getLobbyData')
            .setRequestBody(requestPayload.requestBody)
            .get(requestPayload.requestorCallback)
    }
}